import 'svelte/internal/disclose-version';

RestaurantCard[$.FILENAME] = 'src/components/RestaurantCard.svelte';

import * as $ from 'svelte/internal/client';
import Stars from "./Stars.svelte";
import FavoriteButton from "./FavoriteButton.svelte";
import { formatLocation, priceLabel, truncate } from "../lib/format.js";
import { restaurantUrl } from "../lib/routes.js";
import { highlightSegments } from "../lib/search.js";

var root = $.add_locations($.from_html(`<img alt="" loading="lazy" decoding="async" class="svelte-4pn3jv"/>`), RestaurantCard[$.FILENAME], [[37, 6]]);
var root_1 = $.add_locations($.from_html(`<div class="placeholder svelte-4pn3jv"> </div>`), RestaurantCard[$.FILENAME], [[45, 6]]);
var root_2 = $.add_locations($.from_html(`<span> </span>`), RestaurantCard[$.FILENAME], [[54, 6]]);
var root_3 = $.add_locations($.from_html(`<mark class="svelte-4pn3jv"> </mark>`), RestaurantCard[$.FILENAME], [[64, 67]]);
var root_4 = $.add_locations($.from_html(`<div class="rating svelte-4pn3jv"><!> <span class="split svelte-4pn3jv"><!></span></div>`), RestaurantCard[$.FILENAME], [[77, 6, [[83, 8]]]]);
var root_5 = $.add_locations($.from_html(`<span class="split muted svelte-4pn3jv">No ratings yet</span>`), RestaurantCard[$.FILENAME], [[94, 6]]);
var root_6 = $.add_locations($.from_html(`<p class="blurb svelte-4pn3jv"> </p>`), RestaurantCard[$.FILENAME], [[98, 6]]);
var root_7 = $.add_locations($.from_html(`<li class="svelte-4pn3jv"> </li>`), RestaurantCard[$.FILENAME], [[104, 10]]);
var root_8 = $.add_locations($.from_html(`<ul class="tags svelte-4pn3jv"></ul>`), RestaurantCard[$.FILENAME], [[102, 6]]);

var root_9 = $.add_locations($.from_html(`<article><a class="thumb svelte-4pn3jv" aria-hidden="true" tabindex="-1"><!> <span class="cuisine-chip svelte-4pn3jv"> </span> <!></a> <div class="body svelte-4pn3jv"><div class="top svelte-4pn3jv"><h3 class="svelte-4pn3jv"><a class="svelte-4pn3jv"></a></h3> <!></div> <p class="meta svelte-4pn3jv"><span> </span> <span class="dot svelte-4pn3jv">·</span> <span class="price svelte-4pn3jv"> </span></p> <!> <!> <!></div></article>`), RestaurantCard[$.FILENAME], [
	[
		34,
		0,
		[
			[35, 2, [[47, 4]]],
			[
				60,
				2,
				[
					[61, 4, [[62, 6, [[63, 8]]]]],
					[70, 4, [[71, 6], [72, 6], [73, 6]]]
				]
			]
		]
	]
]);

const $$css = {
	hash: 'svelte-4pn3jv',
	code: '\n  .rating.svelte-4pn3jv { display: flex; flex-direction: column; gap: 1px; }\n  .split.svelte-4pn3jv { font-size: 0.74rem; color: var(--ink-soft); letter-spacing: 0.01em; }\n  .split.muted.svelte-4pn3jv { opacity: 0.75; }\n\n  .card.svelte-4pn3jv {\n    display: flex;\n    flex-direction: column;\n    background: var(--card);\n    border: 1px solid var(--line);\n    border-radius: var(--radius);\n    overflow: hidden;\n    box-shadow: var(--shadow-sm);\n    transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;\n    height: 100%;\n  }\n  .card.svelte-4pn3jv:hover {\n    transform: translateY(-3px);\n    box-shadow: var(--shadow);\n    border-color: var(--line-strong);\n  }\n\n  .thumb.svelte-4pn3jv {\n    position: relative;\n    display: block;\n    aspect-ratio: 16 / 10;\n    background: var(--card-soft);\n    overflow: hidden;\n  }\n  .thumb.svelte-4pn3jv img:where(.svelte-4pn3jv) { width: 100%; height: 100%; object-fit: cover; display: block; }\n  .placeholder.svelte-4pn3jv {\n    width: 100%; height: 100%;\n    display: grid; place-items: center;\n    font-family: var(--font);\n    font-size: 2.6rem;\n    color: var(--accent);\n    background: linear-gradient(140deg, var(--accent-soft), var(--mustard-soft));\n  }\n  .cuisine-chip.svelte-4pn3jv {\n    position: absolute;\n    left: 10px; bottom: 10px;\n    background: rgba(255, 255, 255, 0.92);\n    color: #2f2a26;\n    font-size: 0.72rem;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    padding: 4px 10px;\n    border-radius: var(--radius-pill);\n    backdrop-filter: blur(4px);\n  }\n  /* Closed is a fact, not an error — it gets a neutral chip, not a red one. */\n  .open-chip.svelte-4pn3jv {\n    position: absolute;\n    right: 10px; top: 10px;\n    background: var(--sage);\n    color: #fff;\n    font-size: 0.7rem;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    padding: 4px 10px;\n    border-radius: var(--radius-pill);\n    backdrop-filter: blur(4px);\n  }\n  .open-chip.closed.svelte-4pn3jv { background: rgba(47, 42, 38, 0.74); }\n\n  .body.svelte-4pn3jv { padding: 14px 16px 16px; display: flex; flex-direction: column; gap: 7px; flex: 1; }\n  .top.svelte-4pn3jv { display: flex; align-items: flex-start; gap: 8px; }\n  h3.svelte-4pn3jv { font-size: 1.06rem; line-height: 1.25; flex: 1; }\n  h3.svelte-4pn3jv a:where(.svelte-4pn3jv):hover { color: var(--accent); }\n  mark.svelte-4pn3jv { background: var(--mustard-soft); color: inherit; border-radius: 4px; padding: 0 2px; }\n\n  .meta.svelte-4pn3jv {\n    margin: 0;\n    font-size: 0.84rem;\n    color: var(--ink-soft);\n    display: flex;\n    gap: 6px;\n    align-items: center;\n    flex-wrap: wrap;\n  }\n  .dot.svelte-4pn3jv { color: var(--ink-faint); }\n  .price.svelte-4pn3jv { color: var(--sage); font-weight: 600; }\n\n  .blurb.svelte-4pn3jv {\n    margin: 2px 0 0;\n    font-size: 0.88rem;\n    line-height: 1.45;\n    color: var(--ink-soft);\n  }\n\n  .tags.svelte-4pn3jv { list-style: none; display: flex; gap: 6px; flex-wrap: wrap; margin: auto 0 0; padding: 6px 0 0; }\n  .tags.svelte-4pn3jv li:where(.svelte-4pn3jv) {\n    font-size: 0.72rem;\n    color: var(--ink-soft);\n    background: var(--card-soft);\n    border: 1px solid var(--line);\n    padding: 3px 9px;\n    border-radius: var(--radius-pill);\n  }\n\n  .compact.svelte-4pn3jv .body:where(.svelte-4pn3jv) { padding: 12px 14px; }\n  .compact.svelte-4pn3jv h3:where(.svelte-4pn3jv) { font-size: 0.98rem; }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function RestaurantCard($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, RestaurantCard);
	$.append_styles($$anchor, $$css);

	let terms = $.prop($$props, 'terms', 19, () => []),
		compact = $.prop($$props, 'compact', 3, false);

	const href = $.tag($.derived(() => restaurantUrl($$props.restaurant)), 'href');
	const nameSegments = $.tag($.derived(() => highlightSegments($$props.restaurant.name, terms())), 'nameSegments');
	const location = $.tag($.derived(() => formatLocation($$props.restaurant)), 'location');

	// A dead photo URL should fall back to the letter tile, not leave a grey hole.
	let imageBroken = $.tag($.state(false), 'imageBroken');

	// An admin-uploaded image outranks the provider's: a person chose it. `photoUrl` comes from
	// the expiring source cache, so it can vanish between refreshes — the letter tile covers that.
	const image = $.tag($.derived(() => $$props.restaurant.thumbnailUrl || $$props.restaurant.photoUrl || null), 'image');

	// `combined` is filled at read time from the expiring cache, so it can be absent on a page
	// served before an ingest — fall back to the site's own rating rather than dropping the stars.
	const combined = $.tag(
		$.derived(() => $$props.restaurant.combined ?? ($$props.restaurant.reviewCount > 0
			? {
				rating: $$props.restaurant.ratingAverage,
				ownCount: $$props.restaurant.reviewCount,
				providerCount: 0
			}
			: null)),
		'combined'
	);

	const providerLabel = $.tag(
		$.derived(() => $.strict_equals($.get(combined)?.providerSource, "yelp")
			? "Yelp"
			: $.strict_equals($.get(combined)?.providerSource, "google") ? "Google" : "Google"),
		'providerLabel'
	);

	var $$exports = { ...$.legacy_api() };
	var article = root_9();
	let classes;
	var a = $.child(article);
	var node = $.child(a);

	{
		var consequent = ($$anchor) => {
			var img = root();

			$.template_effect(() => $.set_attribute(img, 'src', $.get(image)));

			$.event('error', img, function error() {
				return $.set(imageBroken, true);
			});

			$.replay_events(img);
			$.append($$anchor, img);
		};

		var alternate = ($$anchor) => {
			var div = root_1();
			var text = $.child(div, true);

			$.reset(div);
			$.template_effect(($0) => $.set_text(text, $0), [() => $$props.restaurant.name.slice(0, 1)]);
			$.append($$anchor, div);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($.get(image) && !$.get(imageBroken)) $$render(consequent); else $$render(alternate, -1);
			}),
			'if',
			RestaurantCard,
			36,
			4
		);
	}

	var span = $.sibling(node, 2);
	var text_1 = $.child(span, true);

	$.reset(span);

	var node_1 = $.sibling(span, 2);

	{
		var consequent_1 = ($$anchor) => {
			var span_1 = root_2();
			let classes_1;
			var text_2 = $.child(span_1, true);

			$.reset(span_1);

			$.template_effect(() => {
				classes_1 = $.set_class(span_1, 1, 'open-chip svelte-4pn3jv', null, classes_1, { closed: !$$props.restaurant.openNow });
				$.set_text(text_2, $$props.restaurant.openNow ? "Open now" : "Closed");
			});

			$.append($$anchor, span_1);
		};

		$.add_svelte_meta(
			() => $.if(node_1, ($$render) => {
				if ($.equals($$props.restaurant.openNow, null, false)) $$render(consequent_1);
			}),
			'if',
			RestaurantCard,
			53,
			4
		);
	}

	$.reset(a);

	var div_1 = $.sibling(a, 2);
	var div_2 = $.child(div_1);
	var h3 = $.child(div_2);
	var a_1 = $.child(h3);

	$.add_svelte_meta(
		() => $.each(a_1, 21, () => $.get(nameSegments), $.index, ($$anchor, segment) => {
			var fragment = $.comment();
			var node_2 = $.first_child(fragment);

			{
				var consequent_2 = ($$anchor) => {
					var mark = root_3();
					var text_3 = $.child(mark, true);

					$.reset(mark);
					$.template_effect(() => $.set_text(text_3, $.get(segment).text));
					$.append($$anchor, mark);
				};

				var alternate_1 = ($$anchor) => {
					var text_4 = $.text();

					$.template_effect(() => $.set_text(text_4, $.get(segment).text));
					$.append($$anchor, text_4);
				};

				$.add_svelte_meta(
					() => $.if(node_2, ($$render) => {
						if ($.get(segment).match) $$render(consequent_2); else $$render(alternate_1, -1);
					}),
					'if',
					RestaurantCard,
					64,
					48
				);
			}

			$.append($$anchor, fragment);
		}),
		'each',
		RestaurantCard,
		64,
		10
	);

	$.reset(a_1);
	$.reset(h3);

	var node_3 = $.sibling(h3, 2);

	$.add_svelte_meta(
		() => FavoriteButton(node_3, {
			get restaurant() {
				return $$props.restaurant;
			}
		}),
		'component',
		RestaurantCard,
		67,
		6,
		{ componentTag: 'FavoriteButton' }
	);

	$.reset(div_2);

	var p = $.sibling(div_2, 2);
	var span_2 = $.child(p);
	var text_5 = $.child(span_2, true);

	$.reset(span_2);

	var span_3 = $.sibling(span_2, 4);
	var text_6 = $.child(span_3, true);

	$.reset(span_3);
	$.reset(p);

	var node_4 = $.sibling(p, 2);

	{
		var consequent_5 = ($$anchor) => {
			var div_3 = root_4();
			var node_5 = $.child(div_3);

			$.add_svelte_meta(
				() => Stars(node_5, {
					get value() {
						return $.get(combined).rating;
					},
					count: null,
					size: 15
				}),
				'component',
				RestaurantCard,
				78,
				8,
				{ componentTag: 'Stars' }
			);

			var span_4 = $.sibling(node_5, 2);
			var node_6 = $.child(span_4);

			{
				var consequent_3 = ($$anchor) => {
					var text_7 = $.text();

					$.template_effect(($0) => $.set_text(text_7, `${$.get(combined).ownCount ?? ''} Upsorok + ${$0 ?? ''} ${$.get(providerLabel) ?? ''}`), [() => $.get(combined).providerCount.toLocaleString()]);
					$.append($$anchor, text_7);
				};

				var consequent_4 = ($$anchor) => {
					var text_8 = $.text();

					$.template_effect(() => $.set_text(text_8, `${$.get(combined).ownCount ?? ''} Upsorok review${$.strict_equals($.get(combined).ownCount, 1) ? "" : "s"}`));
					$.append($$anchor, text_8);
				};

				var alternate_2 = ($$anchor) => {
					var text_9 = $.text();

					$.template_effect(($0) => $.set_text(text_9, `${$0 ?? ''} ${$.get(providerLabel) ?? ''} review${$.strict_equals($.get(combined).providerCount, 1) ? "" : "s"}`), [() => $.get(combined).providerCount.toLocaleString()]);
					$.append($$anchor, text_9);
				};

				$.add_svelte_meta(
					() => $.if(node_6, ($$render) => {
						if ($.get(combined).ownCount > 0 && $.get(combined).providerCount > 0) $$render(consequent_3); else if ($.get(combined).ownCount > 0) $$render(consequent_4, 1); else $$render(alternate_2, -1);
					}),
					'if',
					RestaurantCard,
					84,
					10
				);
			}

			$.reset(span_4);
			$.reset(div_3);
			$.append($$anchor, div_3);
		};

		var alternate_3 = ($$anchor) => {
			var span_5 = root_5();

			$.append($$anchor, span_5);
		};

		$.add_svelte_meta(
			() => $.if(node_4, ($$render) => {
				if ($.get(combined)) $$render(consequent_5); else $$render(alternate_3, -1);
			}),
			'if',
			RestaurantCard,
			76,
			4
		);
	}

	var node_7 = $.sibling(node_4, 2);

	{
		var consequent_6 = ($$anchor) => {
			var p_1 = root_6();
			var text_10 = $.child(p_1, true);

			$.reset(p_1);
			$.template_effect(($0) => $.set_text(text_10, $0), [() => truncate($$props.restaurant.description, 110)]);
			$.append($$anchor, p_1);
		};

		$.add_svelte_meta(
			() => $.if(node_7, ($$render) => {
				if (!compact() && $$props.restaurant.description) $$render(consequent_6);
			}),
			'if',
			RestaurantCard,
			97,
			4
		);
	}

	var node_8 = $.sibling(node_7, 2);

	{
		var consequent_7 = ($$anchor) => {
			var ul = root_8();

			$.add_svelte_meta(
				() => $.each(ul, 20, () => $$props.restaurant.tags.slice(0, 3), (tag) => tag, ($$anchor, tag) => {
					var li = root_7();
					var text_11 = $.child(li, true);

					$.reset(li);
					$.template_effect(() => $.set_text(text_11, tag));
					$.append($$anchor, li);
				}),
				'each',
				RestaurantCard,
				103,
				8
			);

			$.reset(ul);
			$.append($$anchor, ul);
		};

		$.add_svelte_meta(
			() => $.if(node_8, ($$render) => {
				if (!compact() && $$props.restaurant.tags?.length) $$render(consequent_7);
			}),
			'if',
			RestaurantCard,
			101,
			4
		);
	}

	$.reset(div_1);
	$.reset(article);

	$.template_effect(
		($0) => {
			classes = $.set_class(article, 1, 'card svelte-4pn3jv', null, classes, { compact: compact() });
			$.set_attribute(a, 'href', $.get(href));
			$.set_text(text_1, $$props.restaurant.cuisine);
			$.set_attribute(a_1, 'href', $.get(href));
			$.set_text(text_5, $.get(location));
			$.set_text(text_6, $0);
		},
		[() => priceLabel($$props.restaurant.priceLevel)]
	);

	$.append($$anchor, article);

	return $.pop($$exports);
}